// extracted by mini-css-extract-plugin
export default {"error-view":"ErrorView_error-view__Yy0HL","message":"ErrorView_message__A4b4D","animation":"ErrorView_animation__9g3i6"};